export default __webpack_public_path__ + "static/media/gt1030.a358c8ef.jpg";